var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"ireport-post",staticClass:"irepoter-post-gallery-slick container"},_vm._l((_vm.images),function(img,index){return _c('div',{staticClass:"container"},[_c('div',[_c('img',{attrs:{"src":img.path_url,"alt":"images"}})])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }